/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmVectorStoresListFilesInBatch } from "../../funcs/llmVectorStoresListFilesInBatch.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListVectorStoreFilesInBatchRequest$inboundSchema,
};

export const tool$llmVectorStoresListFilesInBatch: ToolDefinition<typeof args> =
  {
    name: "llm-vector-stores-list-files-in-batch",
    description: `List files in a batch

Retrieves a paginated list of all files within a specific batch operation.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await llmVectorStoresListFilesInBatch(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
